<template><div v-if="siteError" class="site-startup" role="alert">{{ siteError }}</div><router-view v-else-if="siteVerified" /><div v-else-if="showLoading" class="site-startup" role="status"><img v-if="siteLogo" :src="siteLogo" @error="siteLogoError" :alt="siteName" style="max-width: 220px; max-height: 64px"><span v-else-if="siteName">{{ siteName }}</span><span>正在加载…</span></div></template>
<script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { siteVerified, siteError, siteLogo, siteName, siteLogoError } from '@/composables/useSiteConfig'
import preserveModifiedLinkNavigation from '@/utils/nativeLinks'

export default {
  name: 'App',
  setup() {
    const showLoading = ref(false)
    const loadingTimer = setTimeout(() => { showLoading.value = true }, 3000)
    watch([siteVerified, siteError], ([verified, error]) => {
      if (verified || error) {
        clearTimeout(loadingTimer)
        showLoading.value = false
      }
    }, { immediate: true })
    onMounted(() => document.addEventListener('click', preserveModifiedLinkNavigation, true))
    onBeforeUnmount(() => {
      clearTimeout(loadingTimer)
      document.removeEventListener('click', preserveModifiedLinkNavigation, true)
    })
    return { showLoading, siteLogoError, siteVerified, siteError, siteLogo, siteName }
  },
}
</script>

